import RiskDataSection from './RiskDataSection'

export default RiskDataSection
